var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0956 25.2259C13.9312 25.2259 13.9312 25.2259 13.7669 25.2259C10.8079 25.2259 7.84903 25.2259 4.89011 25.2259C4.23258 25.2259 3.90381 24.901 3.90381 24.2513C3.90381 21.6523 4.56135 19.2157 6.0408 16.9415C7.19149 15.3171 8.50656 14.18 10.1504 13.3679C10.1504 13.3679 10.3148 13.3679 10.3148 13.2054C8.50657 12.0683 7.68464 10.4439 7.52026 8.33223C7.52026 6.70784 8.1778 5.24589 9.32849 4.10881C11.7942 1.83466 15.5751 1.9971 17.7121 4.43369C20.0135 7.03272 19.5203 11.0937 16.397 13.2054C17.2189 13.6927 18.0408 14.18 18.6984 14.6674C16.397 15.3171 14.5888 16.6166 13.6025 18.7283C12.6162 21.0025 12.7806 23.1142 14.0956 25.2259Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0956 25.2259C13.9312 25.2259 13.9312 25.2259 13.7669 25.2259C10.8079 25.2259 7.84903 25.2259 4.89011 25.2259C4.23258 25.2259 3.90381 24.901 3.90381 24.2513C3.90381 21.6523 4.56135 19.2157 6.0408 16.9415C7.19149 15.3171 8.50656 14.18 10.1504 13.3679C10.1504 13.3679 10.3148 13.3679 10.3148 13.2054C8.50657 12.0683 7.68464 10.4439 7.52026 8.33223C7.52026 6.70784 8.1778 5.24589 9.32849 4.10881C11.7942 1.83466 15.5751 1.9971 17.7121 4.43369C20.0135 7.03272 19.5203 11.0937 16.397 13.2054C17.2189 13.6927 18.0408 14.18 18.6984 14.6674C16.397 15.3171 14.5888 16.6166 13.6025 18.7283C12.6162 21.0025 12.7806 23.1142 14.0956 25.2259Z",
    fill: "url(#paint0_linear_335_9617)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.192 27.5C23.005 27.5 26.0961 24.4455 26.0961 20.6776C26.0961 16.9096 23.005 13.8551 19.192 13.8551C15.3789 13.8551 12.2878 16.9096 12.2878 20.6776C12.2878 24.4455 15.3789 27.5 19.192 27.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.192 27.5C23.005 27.5 26.0961 24.4455 26.0961 20.6776C26.0961 16.9096 23.005 13.8551 19.192 13.8551C15.3789 13.8551 12.2878 16.9096 12.2878 20.6776C12.2878 24.4455 15.3789 27.5 19.192 27.5Z",
    fill: "url(#paint1_linear_335_9617)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.192 27.5C23.005 27.5 26.0961 24.4455 26.0961 20.6776C26.0961 16.9096 23.005 13.8551 19.192 13.8551C15.3789 13.8551 12.2878 16.9096 12.2878 20.6776C12.2878 24.4455 15.3789 27.5 19.192 27.5Z",
    fill: "url(#paint2_linear_335_9617)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8498 18.2429C20.343 18.8926 21.0005 19.3799 21.4937 20.0297C21.3293 20.1921 21.0005 20.517 20.8361 20.6794C20.0142 21.4916 19.1923 22.3038 18.3704 23.116C17.8772 23.6034 17.3841 24.0907 17.0553 24.4156H16.8909C16.3978 24.4156 15.9046 24.4156 15.4115 24.4156C15.2471 24.4156 15.2471 24.4156 15.2471 24.2531C15.2471 23.7658 15.2471 23.2785 15.2471 22.7912V22.6287C16.8909 21.1668 18.3704 19.7048 19.8498 18.2429Z",
    fill: "url(#paint3_linear_335_9617)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1508 19.38C21.6576 18.8927 21.0001 18.2429 20.3425 17.5932C20.5069 17.5932 20.5069 17.4307 20.6713 17.4307C20.8357 17.2683 21.0001 17.2683 21.1645 17.1058C21.3288 16.9434 21.6576 16.9434 21.822 17.1058C22.1508 17.4307 22.4795 17.7556 22.8083 18.0805C22.9727 18.2429 22.9727 18.5678 22.8083 18.7302C22.6439 19.0551 22.4795 19.2175 22.1508 19.38Z",
    fill: "url(#paint4_linear_335_9617)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_335_9617",
    x1: 3.90381,
    y1: 13.8982,
    x2: 19.231,
    y2: 13.8982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_335_9617",
    x1: 12.2684,
    y1: 20.6028,
    x2: 26.1283,
    y2: 20.6028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_335_9617",
    x1: 12.2684,
    y1: 20.6028,
    x2: 26.1283,
    y2: 20.6028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_335_9617",
    x1: 15.4036,
    y1: 21.3593,
    x2: 21.6554,
    y2: 21.3593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_335_9617",
    x1: 20.4587,
    y1: 18.1651,
    x2: 23.0593,
    y2: 18.1651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.c5566cf055609a79b6a7ece5d5c18568.svg";
export { ForwardRef as ReactComponent };